export default {"src":"/_next/static/media/wave.8d7413c4.svg","height":480,"width":1920,"blurWidth":0,"blurHeight":0};